<template>
  <div class="LoadingIcon inline-block">
    <img
      src="/icons/spinner.svg"
      class="spin inline-block"
      :class="{
        'h-18 w-18': size === 'base',
        'h-24 w-24': size === 'lg',
        'h-32 w-32': size === 'xl',
      }"
      :alt="$t('loading')"
    >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  size?: 'xl' | 'lg' | 'base';
}

withDefaults(defineProps<Props>(), {
  size: 'base',
});
</script>

<style scoped lang="postcss">
</style>
